export default Object.freeze({
  comma: function (num) {
    let len, point, str;

    num = num + "";
    point = num.length % 3;
    len = num.length;

    str = num.substring(0, point);
    while (point < len) {
      if (str != "") str += ",";
      str += num.substring(point, point + 3);
      point += 3;
    }

    return str;
  },
  onlyNumber: function (e, is_minus, is_comma) {
    let value = e.target.value;
    let value_format = value.replace(/[^-\.0-9]/g, "");
    e.target.value = value_format;

    let comma_array = value_format.split(".");
    let minus_array = value_format.split("-");
    try {
      if (is_minus == true) {
        let minus_index = value_format.indexOf("-");
        if (minus_index > -1) {
          if (minus_index != 0) {
            throw new Error("minus error");
          }
          let minus_0_index = value_format.indexOf("-0");
          if (minus_0_index > -1) {
            throw new Error("minus error");
          }
        }
        if (minus_array.length > 2) {
          throw new Error("minus error");
        } else {
          e.target.value = value_format;
        }
      } else {
        let minus_index = value_format.indexOf("-");
        if (minus_index > -1) {
          throw new Error("minus error");
        }
      }

      if (is_comma == true) {
        if (comma_array.length > 2) {
          throw new Error("comma error");
        } else {
          e.target.value = value_format;
        }
      } else {
        let comma_index = value_format.indexOf(".");
        if (comma_index > -1) {
          throw new Error("comma error");
        }
      }

      if (value_format.length > 1) {
        let one = value_format.charAt(0);
        let two = value_format.charAt(1);
        if (one == "0" && two != ".") {
          e.target.value = Number(value_format);
        }
      }
    } catch (error) {
      e.target.value = "";
    }
    var event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    e.target.dispatchEvent(event);
  },

  textEnter: (value) => {
    return value.replace(/(\n|\r\n)/g, "<br>");
  },
  productType: (value) => {
    if (!value) {
      return "헤어케어";
    }
    if (value == "hair_care") {
      return "헤어케어";
    }
    if (value == "skin_care") {
      return "스킨케어";
    }
  },

  // 현재 mall_id가 설정 메뉴 노출이 허용된지 확인 (모든 몰에서 허용)
  isSettingAllowed: function(mall_id) {
    return true; // 모든 몰에서 할인 관련 기능 허용
  },
  isExcelTemplateAllowed: function(mall_id) {
    // 엑셀 템플릿 기능이 허용된 mall_id 목록
    const allowedMallIds = ['surping1','supplyqa', 'cafe24plusapp2'];
    return true;
  },
  
  // 엑셀 템플릿에서 사용할 수 있는 컬럼 목록
  getExcelTemplateColumns: function() {
    return [
      { key: "supplier_name", name: "공급사명" },
      { key: "supplier_code", name: "공급사코드" },
      { key: "settlement_no", name: "정산번호" },
      { key: "order_id", name: "주문번호" },
      { key: "order_item_code", name: "품목주문번호" },
      { key: "exchange_no", name: "교환번호" },
      { key: "return_no", name: "반품번호" },
      { key: "order_status", name: "주문상태" },
      { key: "settlement_category", name: "정산항목" },
      { key: "product_name", name: "상품명" },
      { key: "option_name", name: "옵션명" },
      { key: "quantity", name: "수량" },
      { key: "sale_price", name: "판매가" },
      { key: "sale_price_sum", name: "판매가합계" },
      { key: "settlement_amount", name: "정산금액" },
      { key: "additional_discount_amount", name: "고객혜택" },
      { key: "coupon_discount_price", name: "쿠폰/시리얼쿠폰" },
      { key: "add_item_discount_price", name: "할인코드" },
      { key: "shipping_fee", name: "기본배송비" },
      { key: "regional_surcharge_amount", name: "지역별배송비" },
      { key: "individual_shipping_fee", name: "개별배송비" },
      { key: "commission_amount", name: "수수료금액" },
      { key: "commission_percent", name: "수수료율" },
      { key: "penalty_amount", name: "패널티금액" },
      { key: "deduction_amount", name: "공제금액" },
      { key: "refund_amount", name: "환급금액" },
      { key: "settlement_defer_amount", name: "정산보류금액" },
      { key: "exchange_at", name: "교환완료일" },
      { key: "refund_at", name: "반품완료일" },
      { key: "normal_at", name: "배송완료일" },
      { key: "settlement_schedule_at", name: "정산예정일" },
      { key: "settlement_completion_at", name: "정산완료일" },
      { key: "payment_method", name: "결제수단" },
      { key: "payment_company", name: "결제업체" },
      { key: "card_payment_info", name: "카드결제정보" },
      // 추가 항목들
      { key: "product_code", name: "상품코드" },
      { key: "variant_code", name: "품목코드" },
      { key: "product_price", name: "상품가격" },
      { key: "option_price", name: "옵션가격" },
      { key: "purchaseconfirmation_at", name: "구매확정일" }
    ];
  },
});
